/* ==========================================================================
   dev-cart-drawer-summary.js — B-012
   Collapsible cart-drawer delivery estimate.

   The delivery block (.dev-cart-drawer__collapse) is hidden until the shopper
   scrolls the item list (.dev-cart-drawer__items) to its bottom, then expands.
   Scrolling back up re-collapses it. A cart short enough that the list doesn't
   overflow is already "at bottom", so it shows expanded by default.

   Asymmetric hysteresis: expand when within EXPAND_AT px of the bottom, but only
   collapse once scrolled COLLAPSE_AT px away. COLLAPSE_AT is deliberately larger
   than the delivery block's own height — expanding it shrinks the scroller by
   that height, which would otherwise push the list past a symmetric threshold and
   ping-pong the state (restarting the CSS transition every frame). The wide
   collapse band absorbs that shift so the panel stays put until a real scroll-up.

   Bound to the stable <dialog>.dev-cart-drawer__dialog (the cart's AJAX re-render
   only swaps the inner children, not the dialog) with a capturing scroll listener
   (scroll doesn't bubble), plus re-evaluation on open, cart:update and resize.
   ========================================================================== */
(function () {
  var EXPAND_AT = 24; // px from bottom: expand
  var COLLAPSE_AT = 160; // px from bottom: collapse (must exceed delivery height)

  function init(dialog) {
    if (dialog.__summaryBound) return;
    dialog.__summaryBound = true;

    function evaluate() {
      // Only measure when open; a closed <dialog> has zero dimensions, which would
      // read as "at bottom" and flash the panel open.
      if (!dialog.open) return;

      var items = dialog.querySelector('.dev-cart-drawer__items');
      var summary = dialog.querySelector('.dev-cart-drawer__summary');
      if (!items || !summary) return;

      var dist = items.scrollHeight - items.scrollTop - items.clientHeight;
      var expanded = summary.classList.contains('is-expanded');

      // While the shopper is entering a postal code, opening the estimate box grows
      // the delivery block and shrinks the scroller — which would otherwise trip the
      // collapse and yank the input away. Hold the panel open until they close it.
      var ed = summary.querySelector('.estimate-delivery');
      var postalOpen = ed && ed.classList.contains('show-textbox');

      if (!expanded && dist <= EXPAND_AT) {
        summary.classList.add('is-expanded');
      } else if (expanded && dist > COLLAPSE_AT && !postalOpen) {
        summary.classList.remove('is-expanded');
      }
    }

    // scroll doesn't bubble → listen in the capture phase on the stable dialog
    dialog.addEventListener(
      'scroll',
      function (e) {
        var t = e.target;
        if (t && t.classList && t.classList.contains('dev-cart-drawer__items')) {
          evaluate();
        }
      },
      true
    );

    // Re-evaluate after the cart re-renders (add/remove/qty), on open, and resize.
    document.addEventListener('cart:update', function () {
      setTimeout(evaluate, 60);
    });
    window.addEventListener('resize', evaluate);

    // Fires when the dialog opens (attribute flips) and when its inner content is
    // swapped by the AJAX re-render.
    var mo = new MutationObserver(function () {
      setTimeout(evaluate, 60);
    });
    mo.observe(dialog, {
      attributes: true,
      attributeFilter: ['open'],
      childList: true,
      subtree: true,
    });

    evaluate();
  }

  function boot() {
    document.querySelectorAll('.dev-cart-drawer__dialog').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
